export default {
  // define base URL of the API end points here-------------------------

  baseUrl: "https://pm74.paymediasolutions.com/E-Kyc/RDB_Bank/UAT/public/api",
  //  baseUrl: "http://127.0.0.1:8000/api",
//   baseUrl: "https://ekyc.rdb.lk:8082/api"

  // public storage base for product / uploaded images
  storageUrl: "https://pm74.paymediasolutions.com/E-Kyc/RDB_Bank/UAT/public/storage",
  // storageUrl: "http://127.0.0.1:8000/storage",
};